import React, { useState } from "react";
import { useHistory } from "react-router";
import ActivityHeader from "./common/ActivityHeader";
import BurndownChartIntro from "./BurndownChart/BurndownChartIntro";
import BurndownChartPage1 from "./BurndownChart/BurndownChartPage1";
import BurndownChartPage2 from "./BurndownChart/BurndownChartPage2";
import BurndownChartPage3 from "./BurndownChart/BurndownChartPage3";
import BurndownChartFinal from "./BurndownChart/BurndownChartFinal";
import { useSelector } from "react-redux";
import { selectNextTopic } from "../../store/selectors";
import { useKeyTerms } from "../../hooks/useKeyTerms";
import { useActivityLogger } from "../../hooks/useActivityLogger";

const BurndownChart = ({ section, topic }) => {
  useKeyTerms();
  const nextTopic = useSelector((state) => selectNextTopic(state, topic));
  const history = useHistory();
  const SECTIONS = {
    intro: "intro",
    page1: "page1",
    page2: "page2",
    page3: "page3",
    final: "final",
  };
  const [currentSection, setCurrentSection] = useState(SECTIONS.intro);
  const parts = {
    intro: 1,
    page1: 2,
    page2: 3,
    page3: 4,
    final: 5,
  };

  useActivityLogger(topic, currentSection, SECTIONS);

  return (
    <div>
      <ActivityHeader
        section={section}
        topic={topic}
        current={parts[currentSection]}
        total={Object.values(parts).length}
      />

      {currentSection === SECTIONS.intro && (
        <BurndownChartIntro
          onBack={() =>
            history.push(`/app/${section.contentKey}/${topic.contentKey}/3`)
          }
          onContinue={() => setCurrentSection(SECTIONS.page1)}
          color={section.data.accentColor}
        />
      )}

      {currentSection === SECTIONS.page1 && (
        <BurndownChartPage1
          onBack={() => setCurrentSection(SECTIONS.intro)}
          onContinue={() => setCurrentSection(SECTIONS.page2)}
          color={section.data.accentColor}
        />
      )}

      {currentSection === SECTIONS.page2 && (
        <BurndownChartPage2
          onBack={() => setCurrentSection(SECTIONS.page1)}
          onContinue={() => setCurrentSection(SECTIONS.page3)}
          color={section.data.accentColor}
        />
      )}

      {currentSection === SECTIONS.page3 && (
        <BurndownChartPage3
          onBack={() => setCurrentSection(SECTIONS.page2)}
          onContinue={() => setCurrentSection(SECTIONS.final)}
          color={section.data.accentColor}
        />
      )}

      {currentSection === SECTIONS.final && nextTopic && (
        <BurndownChartFinal
          onBack={() => setCurrentSection(SECTIONS.page3)}
          onContinue={() =>
            history.push(
              `/app/${nextTopic.parentContentId}/${nextTopic.contentKey}`
            )
          }
          color={section.data.accentColor}
          template={topic.data.template}
        />
      )}
    </div>
  );
};

export default BurndownChart;
